<template>
  <div>
    <h1>tesrte</h1>
  </div>
</template>

<script>
export default {
  name: 'teste',
  data() {
    return {
      teste: 'teste'
    }
  },
  mounted() {
    console.log('teste')
  }
}


</script>